/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

export type ThumbnailProps = {
  /** Alt text for image */
  alt: string
  /** Source of image */
  src: string
}

const imageCss = css`
  display: flex;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
`

export const Thumbnail = ({ alt, src }: ThumbnailProps) => (
  <img alt={alt} css={imageCss} src={src} />
)

export default Thumbnail
